import { render, staticRenderFns } from "./LeadsHome.vue?vue&type=template&id=53acee15&"
import script from "./LeadsHome.vue?vue&type=script&lang=js&"
export * from "./LeadsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports